import { Outlet } from 'react-router-dom';
import SkillsScopeProvider from '../SkillsScopeProvider';

const PLATFORM_SKILLS_BASE_PATH = '/admin/skills';

/**
 * Platform mount wrapper for `/admin/skills*` via an Outlet layout route.
 */
const PlatformSkillsScopeMount = () => {
    return (
        <SkillsScopeProvider
            scope={{
                kind: 'platform',
                basePath: PLATFORM_SKILLS_BASE_PATH,
            }}
        >
            <Outlet />
        </SkillsScopeProvider>
    );
};

export default PlatformSkillsScopeMount;
